import Header from './components/Header';
import { Navigate, Outlet, Route, Routes, useLocation } from 'react-router-dom';
import Footer from './components/Footer';

function Blog() {
    return (
        <>
            <Header theme="light" accent="Blue" />
            <Outlet></Outlet>
            <Footer />
        </>
    );
}

export default Blog;
